import React, { Suspense, lazy, useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchUserAsync } from "./features/auth/authSlice";
import { Toaster } from "react-hot-toast";
import { useMediaQuery } from "react-responsive";

import { AboutUs } from "./components/EndPages/AboutUs";
import { Refund } from "./components/EndPages/Refund";
import { UserAgreement } from "./components/EndPages/UserAgreement";
import { CopyRight } from "./components/EndPages/CopyRight";
import { Policy } from "./components/EndPages/Policy";
import ProductDescription from "./pages/productDescriptionPage";
import Wishlist from "./pages/wishlist";
import Carts from "./pages/carts";
import SharePopUp from "./components/ProductDescription/SharePopUp";
import ListingPage from "./pages/listingPage";
import OpenPdf from "./components/ProductDescription/OpenPdf";
import MyProfilepage from "./pages/MyProfilepage";
import ViewOrderPage from "./pages/ViewOrderPage";
import Supports from "./pages/supports";
import OurBeliefSystem from "./components/EndPages/OurBeliefSystem";
import AdminDashbd from "./pages/AdminDashbd";
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import { ShippingPolicy } from "./components/EndPages/ShippingPolicy";
import AnalyticsTracker from "./AnalyticsTracker";
import { MoveTopButton, WhatsAppButton } from "./WhatsAppTopButtons";
import Tds from "./pages/race/Tds";
import RacePage from "./pages/race";
import ChambaRacePage from "./pages/race/chamba";
const Home = lazy(() => import("./pages/home"));

export const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
};
function App() {
  const [loading, setLoading] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(1000);
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();

  function getCookie(name) {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookieValue ? cookieValue.split("=")[1] : null;
  }

  const [userID, setUserID] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const userId = getCookie("UserID");
      if (userId && userId !== userID) {
        setUserID(userId);
      }
    }, 500); // Check every 500ms

    return () => clearInterval(interval);
  }, [userID]);

  useEffect(() => {
    if (userID) {
      dispatch(fetchUserAsync(userID));
    }
  }, [dispatch, userID]);

  const scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, c - c / 8);
    }
  };

  // useEffect(() => {
  //   const responsePromise = ccHundred(userID);
  //   responsePromise
  //     .then((response) => {
  //       // console.log(response);
  //     })
  //     .catch((error) => {
  //       // console.error("Error:", error);
  //       // Handle error if necessary
  //     });
  // }, [userID]);

  // useEffect(() => {
  //   const handleScroll = throttle(() => {
  //     const windowHeight = window.innerHeight;
  //     const documentHeight = document.documentElement.scrollHeight;
  //     const bottomOffset = documentHeight - windowHeight - window.pageYOffset;

  //     setScrollPosition(bottomOffset);
  //     setIsScrolled(window.scrollY > 0);
  //   }, 100);

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 501px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 500px)" });

  // Pre-loader effect
  useEffect(() => {
    window.addEventListener("load", () => {
      setTimeout(() => {
        setLoading(false); // Set loading to false after 1.5 seconds
      }, 1500);
    });
  }, []);

  if (loading) {
    return (
      <div id="pre-loader" className="pre-loader">
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <AnalyticsTracker />
      <div className="App">
        <Toaster position="top-right" reverseOrder={true} />
        {window.location.pathname !== "/sign-up" &&
          window.location.pathname !== "/admin/dashboard" &&
          isDesktopOrLaptop && (
            <>
              <WhatsAppButton
                bottom={
                  scrollPosition <= 400 ? Math.max(490, scrollPosition) : "12vh"
                }
              />
              <MoveTopButton
                bottom={
                  scrollPosition <= 400
                    ? Math.max(430, scrollPosition)
                    : "3.5vh"
                }
                onClick={scrollToTop}
                isMobile={false}
              />
            </>
          )}
        {window.location.pathname !== "/sign-up" &&
          window.location.pathname !== "/admin/dashboard" &&
          window.location.pathname !== "/carts" &&
          isTabletOrMobile && (
            <>
              <WhatsAppButton
                bottom={isScrolled ? "17vh" : "15vh"}
                isMobile={true}
              />
              <MoveTopButton
                bottom={undefined}
                onClick={scrollToTop}
                isMobile={true}
                isScrolled={isScrolled}
              />
            </>
          )}
        <div className="app-routes">
          <Suspense
            fallback={
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                Loading...
              </div>
            }
          >
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/aboutUs" element={<AboutUs />} />
              <Route exact path="/refund" element={<Refund />} />
              <Route
                exact
                path="/our_belief_system"
                element={<OurBeliefSystem />}
              />
              <Route
                exact
                path="/shipping_policy"
                element={<ShippingPolicy />}
              />
              <Route exact path="/user_agreement" element={<UserAgreement />} />
              <Route exact path="/copyright" element={<CopyRight />} />
              <Route exact path="/privacypolicy" element={<Policy />} />
              <Route
                exact
                path="/product/:prod_ID"
                element={<ProductDescription />}
              />
              <Route
                exact
                path="/wishlist"
                element={userID ? <Wishlist /> : <Navigate to="/" />}
              />
              <Route
                exact
                path="/carts"
                element={userID ? <Carts /> : <Navigate to="/" />}
              />
              <Route exact path="/share" element={<SharePopUp />} />
              <Route
                exact
                path="/listing-page/:CategoryID/:categoryName"
                element={<ListingPage />}
              />
              <Route
                exact
                path="/listing-page/:brand"
                element={<ListingPage />}
              />

              <Route exact path="/search/:text" element={<ListingPage />} />
              <Route exact path="/manual/:pdfFile" element={<OpenPdf />} />
              <Route
                exact
                path="/user/:profileUrl"
                element={userID ? <MyProfilepage /> : <Navigate to="/" />}
              />
              <Route
                exact
                path="/user/orders/view_order/:order_ID"
                element={<ViewOrderPage />}
              />
              <Route exact path="/support" element={<Supports />} />
              <Route
                path="/admin/dashboard"
                element={
                  userID &&
                    process.env.REACT_APP_ADMIN_USER?.split(",")
                      .map(Number)
                      .includes(Number(userID)) ? (
                    <AdminDashbd />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />

              <Route path="/blog" element={<BlogPage />} />
              <Route path="/race" element={<RacePage />} />
              <Route path="/race/chamba" element={<ChambaRacePage />} />
              <Route path="/race/tds-2025" element={<Tds />} />
              <Route path="/blog/:id" element={<BlogDetailPage />} />
            </Routes>
          </Suspense>
        </div>
      </div>
    </Router>
  );
}

export default App;
